let lastScrollTop = 0;
let bottom = false;

window.onscroll = function() {
  const HeadSection = document.querySelector('.HeadSection, .post-single-header, .prognostic-single-header');
  const HeaderClub = document.querySelector('.HeaderClub');
  const footerNewsletter = document.querySelector('.footerNewsletter');
  const footerClub = document.querySelector('.footer-club');
  const sidebar = document.querySelector(
    '.search_sidebar, .single_blog_sidebar, .single_bet_houses_sidebar, .single_prognostics_sidebar'
  );

  const footer = footerNewsletter ? footerNewsletter : footerClub;

  if (sidebar && HeadSection) {
    const HeadSectionDimensions = HeadSection.getBoundingClientRect();
    const sidebarDimensions = sidebar.getBoundingClientRect();

    /* set height parent sidebar */
    sidebar.parentElement.setAttribute('style', `min-height: ${sidebar.clientHeight}px`)

    /* check scroll direction */
    let st = window.scrollY || document.documentElement.scrollTop;
    if (st > lastScrollTop){
      scrollDirection = 'down';
    } else {
      scrollDirection = 'up';
    }
    lastScrollTop = st <= 0 ? 0 : st;

    if (HeadSectionDimensions.bottom < HeaderClub.clientHeight) {
      const sidebarParentCss = window.getComputedStyle(sidebar.parentElement);
      let sidebarParentWidth = sidebar.parentElement.offsetWidth;
      sidebarParentWidth -= parseFloat(sidebarParentCss.paddingLeft);
      sidebarParentWidth -= parseFloat(sidebarParentCss.paddingRight);

      if (scrollDirection === 'up') {
        if (sidebarDimensions.top < HeaderClub.clientHeight + 20) {
          if (bottom) {
            sidebar.setAttribute(
              'style',
              `position: fixed;
              width: ${sidebarParentWidth}px;
              bottom: ${window.innerHeight - footer.getBoundingClientRect().top + 40}px;`
            );
          } else if (sidebar.clientHeight > window.innerHeight - HeaderClub.clientHeight
            && !isNaN(parseFloat(getComputedStyle(sidebar).bottom))) {
            sidebar.setAttribute(
              'style',
              `position: fixed;
              width: ${sidebarParentWidth}px;
              bottom: ${parseFloat(getComputedStyle(sidebar).bottom) - 20}px;`
            );
          }
        } else {
          bottom = false;
        }
      } else {
        /* if sidebar height less than window */
        if (HeadSectionDimensions.bottom < HeaderClub.clientHeight
          && sidebar.clientHeight <= window.innerHeight - HeaderClub.clientHeight
          && footer.getBoundingClientRect().top >= window.innerHeight) {
          sidebar.setAttribute(
            'style',
            `position: fixed;
            width: ${sidebarParentWidth}px;
            top: ${HeaderClub.clientHeight - 40}px;
            margin-top: ${window.getComputedStyle(sidebar.parentElement.parentElement).marginTop};`
          );

          /* sidebar stop at 50px of bottom */
        } else if (sidebarDimensions.bottom + 50 < window.innerHeight
          && footer.getBoundingClientRect().top >= window.innerHeight) {
          sidebar.setAttribute(
            'style',
            `position: fixed;
            width: ${sidebarParentWidth}px;
            bottom: 50px;`
          );

          /* when reach to footer the sidebar stops */
        } else if (footer.getBoundingClientRect().top < sidebarDimensions.bottom) {
          bottom = true;
          sidebar.setAttribute(
            'style',
            `position: fixed;
            width: ${sidebarParentWidth}px;
            bottom: ${window.innerHeight - footer.getBoundingClientRect().top + 40}px;`
          );

          /* scroll in middle of content */
        } else if (parseFloat(getComputedStyle(sidebar).bottom) < 50) {
          sidebar.setAttribute(
            'style',
            `position: fixed;
              width: ${sidebarParentWidth}px;
              bottom: ${parseFloat(getComputedStyle(sidebar).bottom) + 20}px;`
          );
        }
      }
    } else {
      sidebar.removeAttribute('style');
    }
  }
}
